module.exports = __webpack_public_path__ + "HRA Brochure - After a Portion.pdf";